import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { mapSettingTypeFromDTO } from '@/modules/common/mappers/setting-type.mapper';
import { AvailableSettingsResponse } from '@/modules/settings/types/response/available-settings-response';
import { SettingType } from '@/modules/settings/types/setting-type';
import { axiosInstance } from '@/utils/axios';

/**
 * Fetches the list of available settings types for the current user
 * Returns only settings pages accessible based on user's permissions
 * Filters out unknown setting types to gracefully handle unsupported types
 */
export const getAvailableSettings = async (): Promise<SettingType[]> => {
  const endpoint = '/api/settings/available-types';

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.get<{ data: AvailableSettingsResponse }>(endpoint)
  );

  return response.types
    .map(mapSettingTypeFromDTO)
    .filter((type): type is SettingType => type !== null);
};
